import React from "react";
import { useSelector } from "react-redux";
import AllFilterPagination from "../../FilterAll/AllFilterPagination";
import PostNotFound from "../../../../CustomComponents/AllLoader/PostNotFound";
import CustomReactQuillDescription from "../../../../Common/CustomeLabel/ReactQuill/CustomReactQuillDescription";
import YourPost from "../../../../Common/Label/YourPost";
import { navigateToNextTab } from "../../../../Common/FewCommonMethods";
import ImageWithFallback from "../../../../../common/ImageWithFallback";
import { formatNumberWithCommas } from "../../../../Common/AllDateTimeReleventFormate";
import DisplayFileExtensionWise from "../../../../Common/FilesRelevent/DisplayFileExtensionWise";
import CommonPagination from "../../../../Common/PaginationComponet/CommonPagination";
import { useAllFilterBaseContext } from "../../../../../Context/AllFilterBaseContext";

export default function AllPackagedServices({ activeTab }) {
  const allots = useSelector(({ ots: { getfilterdots } }) => getfilterdots);
  const getmineotslist = allots?.response || [];
  const { state, setPageNumber } = useAllFilterBaseContext();

  return (
    <div className="col-lg-9 col-md-8 filter-right pack-pag">

      <h2>All One Time Services (OTS)</h2>
      {Array.isArray(getmineotslist) && getmineotslist.length > 0 ? (
        <div className="row packaged-row">
          {Array.isArray(getmineotslist) &&
            getmineotslist?.map((item, index) => (
              <div className="col-lg-4 col-md-6 col-6" key={index}>
                <div className="d-flex post-sold">
                  <YourPost item={item} />
                </div>
                <div
                  className="packaged-img"
                  onClick={() =>
                    navigateToNextTab(`packageddetails/${item?.id}`)
                  }
                >
                  <DisplayFileExtensionWise item={{ file: Array.isArray(item?.files) && item?.files[0]?.file }} className="w-100" alt="" />

                  <h6>{item?.title}</h6>
                  <p>Price : $ {formatNumberWithCommas(item?.price)}</p>
                  <p
                    style={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {<CustomReactQuillDescription value={item.description}
                      displyreadorless={false} />}
                  </p>
                </div>
              </div>
            ))}

          {allots && (
            <CommonPagination
              totalitemcounts={
                activeTab == "allpost"
                  ? allots?.count?.count
                  : activeTab == "recentview"
                    ? allots?.count?.viewed_count
                    : activeTab == "savepost"
                      ? allots?.count?.wishlist_count
                      : allots?.count?.count
              }
              size={15}
              pageNumber={state?.pageNumber}
              setPageNumber={setPageNumber}
            />
          )}
        </div>
      ) : (
        <PostNotFound title={"One Time Services (OTS) Not Found..."} />
      )}
    </div>
  );
}
